import { render, staticRenderFns } from "./LocalDelivery.vue?vue&type=template&id=5219bd19"
import script from "./LocalDelivery.vue?vue&type=script&lang=ts"
export * from "./LocalDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports